import { Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import { WorkflowStatus } from 'dashboard/models/workflow';
import Sticker from 'design-system/components/Sticker';
import { Variant } from 'design-system/theme';

export const StickerContainer = styled('div')`
  display: grid;
  grid-auto-columns: min-content;
  grid-auto-flow: column;

  grid-column-gap: ${Spacing[2]};
  grid-row-gap: ${Spacing[2]};
  white-space: nowrap;
`;

interface WorkflowStatusStickerProps {
  workflowStatus: WorkflowStatus | boolean;
}

const WorkflowStatusSticker = ({ workflowStatus }: WorkflowStatusStickerProps) => {
  const getStickerStatus = (): [Exclude<Variant, 'inverse'>, string] => {
    switch (workflowStatus) {
      case true:
      case WorkflowStatus.Running: {
        return ['success', 'Active'];
      }
      case false:
      case WorkflowStatus.Paused: {
        return ['basic', 'Inactive'];
      }
      case WorkflowStatus.Archived: {
        return ['danger', 'Archived'];
      }
      default:
        return ['danger', 'Unknown'];
    }
  };

  const [variantType, statusMessage] = getStickerStatus();

  return (
    <StickerContainer>
      <Sticker variant={variantType} data-test='workflow-status-sticker__sticker'>
        {statusMessage}
      </Sticker>
    </StickerContainer>
  );
};

export default WorkflowStatusSticker;
